<div class="vc-inline">
   <p-checkbox
      [binary]="true"
      [disabled]="disabled"
      [(ngModel)]="value"
      [required]="required"
      (onChange)="handleCheckboxChange($event.checked)"
      (onBlur)="onTouched()"
      [inputId]="inputId"
      #ngModelCtrl="ngModel"
      [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)"></p-checkbox>

   <label
      class="vc-inline-label"
      [for]="inputId">
      {{ label }}
   </label>
</div>
